import { LifeglovLinerStock } from '@bioliberty/lifemind';
import { getQueryCacheKey } from '../util';
import { HttpMethod } from '../util/http';
import { tms } from './tms';

export interface GetLifeglovLinerStocksParams {
  subtenantIds?: number[];
}

export interface EnrichedLifeglovLinerStock extends LifeglovLinerStock {
  adjustment: number;
  used: number;
  available: number;
}

export interface UpdateLifeglovLinerStockParams {
  id: number;
  count: number;
  adjustment: number;
}

const lifeglovLinerStockApi = tms.injectEndpoints({
  endpoints: (builder) => ({
    getLifeglovLinerStocks: builder.query<EnrichedLifeglovLinerStock[], GetLifeglovLinerStocksParams>({
      query: ({ subtenantIds }) => ({
        url: `lifeglov-liner-stocks`,
        method: HttpMethod.Get,
        params: {
          subtenantIds: subtenantIds?.join(',') || undefined
        }
      }),
      providesTags: (_result, _error, params) => [
        { type: 'LifeglovLinerStock', id: getQueryCacheKey(params, 'lifeglov-liner-stock') }
      ]
    }),
    updateLifeglovLinerStock: builder.mutation<void, UpdateLifeglovLinerStockParams>({
      query: ({ id, ...body }) => ({
        url: `lifeglov-liner-stocks/${id}`,
        method: HttpMethod.Put,
        body
      }),
      invalidatesTags: ['LifeglovLinerStock']
    })
  })
});

export const { useGetLifeglovLinerStocksQuery, useUpdateLifeglovLinerStockMutation } = lifeglovLinerStockApi;
